import { IUserInfoState } from '../states'
import { UserInfoActionTypes, UserInfoTypeKeys } from '../types'

export const initialUserInfoState: IUserInfoState = {
  id: 0,
  name: '',
  firstName: '',
  lastName: '',
  dni: '',
  email: '',
  town: { id: 0, name: '' },
  notificationFeedback: false,
  notificationReservationConfirmation: false,
  locale: 'ca',
  isPenalized: false,
  isLoadingUserInfo: false,
  experienced: true,
  documentationRequired: false,
  stripeIds: [],
  paymentMethodId: '',
  accountId: '',
  paymentMethodLastFour: '',
  isGuest: false,
  showGuestSignUp: false,
  guestSignUpScreen: 'intro',
  prm: false,
  birthDay: '',
  birthMonth: '',
  birthYear: '',
  gender: '',
  settlement: '',
  additionalPhone: '',
  additionalPhoneCallingCode: '',
  additionalPhoneCountry: undefined,
  documents: []
}

const userInfo = (
  state: IUserInfoState = initialUserInfoState,
  action: UserInfoActionTypes
): IUserInfoState => {
  switch (action.type) {
    case UserInfoTypeKeys.SET_USER_INFO:
      // A real session ends guest mode: the town comes from the profile now, so
      // the towns modal must not ask for it again.
      return { ...state, ...action.payload, isGuest: false, showGuestSignUp: false }
    case UserInfoTypeKeys.SET_USER_INFO_EMAIL:
      return { ...state, email: action.payload }
    case UserInfoTypeKeys.SET_USER_INFO_DNI:
      return { ...state, dni: action.payload }
    case UserInfoTypeKeys.SET_USER_INFO_NAME:
      return { ...state, firstName: action.payload }
    case UserInfoTypeKeys.SET_USER_INFO_LAST_NAME:
      return { ...state, lastName: action.payload }
    case UserInfoTypeKeys.SET_USER_INFO_BIRTH_DAY:
      return { ...state, birthDay: action.payload }
    case UserInfoTypeKeys.SET_USER_INFO_BIRTH_MONTH:
      return { ...state, birthMonth: action.payload }
    case UserInfoTypeKeys.SET_USER_INFO_BIRTH_YEAR:
      return { ...state, birthYear: action.payload }
    case UserInfoTypeKeys.SET_USER_INFO_GENDER:
      return { ...state, gender: action.payload }
    case UserInfoTypeKeys.SET_USER_INFO_IS_PRM:
      return { ...state, prm: action.payload }
    case UserInfoTypeKeys.SET_USER_INFO_SETTLEMENT:
      return { ...state, settlement: action.payload }
    case UserInfoTypeKeys.SET_USER_INFO_ADDITIONAL_PHONE:
      return { ...state, additionalPhone: action.payload }
    case UserInfoTypeKeys.SET_USER_INFO_ADDITIONAL_PHONE_CALLING_CODE:
      return { ...state, additionalPhoneCallingCode: action.payload }
    case UserInfoTypeKeys.SET_USER_INFO_ADDITIONAL_PHONE_COUNTRY:
      return { ...state, additionalPhoneCountry: action.payload }
    case UserInfoTypeKeys.CHANGE_USER_LENGUAGE:
      return { ...state, locale: action.payload }
    case UserInfoTypeKeys.CHANGE_CONFIRMATION_FLAG:
      return {
        ...state,
        notificationReservationConfirmation: !state.notificationReservationConfirmation
      }
    case UserInfoTypeKeys.CHANGE_FEEDBACK_FLAG:
      return {
        ...state,
        notificationFeedback: !state.notificationFeedback
      }
    case UserInfoTypeKeys.SET_IS_USER_PENALIZED:
      return {
        ...state,
        isPenalized: true
      }
    case UserInfoTypeKeys.IS_LOADING_USER_INFO:
      return {
        ...state,
        isLoadingUserInfo: action.payload
      }
    case UserInfoTypeKeys.SET_IS_USER_EXPERIENCED:
      return {
        ...state,
        experienced: action.payload
      }
    case UserInfoTypeKeys.SET_PAYMENT_METHOD_ID: {
      return {
        ...state,
        paymentMethodId: action.payload
      }
    }
    case UserInfoTypeKeys.SET_STRIPE_CUSTOMER_IDS: {
      return {
        ...state,
        stripeIds: action.payload
      }
    }
    case UserInfoTypeKeys.SET_ACCOUNT_ID: {
      return {
        ...state,
        accountId: action.payload
      }
    }
    case UserInfoTypeKeys.SET_PAYMENT_GATEWAY: {
      return {
        ...state,
        paymentGateway: action.payload
      }
    }
    case UserInfoTypeKeys.SET_TOWN: {
      return {
        ...state,
        town: action.payload
      }
    }
    case UserInfoTypeKeys.SET_GUEST_MODE: {
      return {
        ...state,
        isGuest: true
      }
    }
    case UserInfoTypeKeys.SHOW_GUEST_SIGN_UP: {
      return { ...state, showGuestSignUp: true, guestSignUpScreen: action.payload }
    }
    case UserInfoTypeKeys.SET_GUEST_SIGN_UP_SCREEN: {
      return { ...state, guestSignUpScreen: action.payload }
    }
    case UserInfoTypeKeys.HIDE_GUEST_SIGN_UP: {
      return { ...state, showGuestSignUp: false }
    }
    case UserInfoTypeKeys.SET_DOCUMENTS: {
      return {
        ...state,
        documents: action.payload
      }
    }
    default:
      return state
  }
}

export default userInfo
